import { useCallback, useRef } from 'react';

export const useBodyScroll = () => {
  const bodyOverflow = useRef('');
  const bodyPosition = useRef('');

  const scrollState = useRef(true);

  return {
    setBodyScroll: useCallback((enable: boolean) => {
      if (enable === scrollState.current) return;
      scrollState.current = enable;
      if (enable) {
        document.body.style.overflow = bodyOverflow.current;
        document.body.style.position = bodyPosition.current;
      } else {
        bodyOverflow.current = document.body.style.overflow;
        bodyPosition.current = document.body.style.position;
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'relative';
      }
    }, []),
  };
};
